
 $(document).ready(function() {
  var dirRtlFlag = false;
if ($("html").attr('dir') == 'rtl') {
 dirRtlFlag = true;
}

$('.hp-about-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000, // fading is smoother with a lower speed
  autoplay: true,
  autoplaySpeed: 4000, // usually higher than animation speed
  rtl: dirRtlFlag,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  prevArrow: $('.hp-about-slider2__prev'),
  nextArrow: $('.hp-about-slider2__next')
 });

 $('.hp-about-slider2').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000, // fading is smoother with a lower speed
  autoplay: true,
  autoplaySpeed: 4000, // usually higher than animation speed
  rtl: dirRtlFlag,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  prevArrow: $('.hp-about-slider2__prev'),
  nextArrow: $('.hp-about-slider2__next')
  });

  $('.hp-about-slider3').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000, // fading is smoother with a lower speed
    autoplay: true,
    autoplaySpeed: 4000, // usually higher than animation speed
    rtl: dirRtlFlag,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    prevArrow: $('.hp-about-slider2__prev'),
    nextArrow: $('.hp-about-slider2__next')
    });

    $('.hp-about-slider4').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 1000, // fading is smoother with a lower speed
      autoplay: true,
      autoplaySpeed: 4000, // usually higher than animation speed
      rtl: dirRtlFlag,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      prevArrow: $('.hp-about-slider2__prev'),
      nextArrow: $('.hp-about-slider2__next')
      });


 $('.company-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 4000,
  fade:true,
  autoplay: true,
   autoplaySpeed: 1500,
  rtl: dirRtlFlag,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: $('.company-slider__prev'),
  nextArrow: $('.company-slider__next'),
  });


  $('.logo-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 4500,
    autoplay: true,
    autoplaySpeed: 1000,
    rtl: dirRtlFlag,
    centerMode: false,
    slidesToShow: 11,
    slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1650,
        settings: {
        slidesToShow: 9,
        slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1350,
        settings: {
        slidesToShow: 7,
        slidesToScroll: 1
        }
      },
      {
        breakpoint: 1050,
        settings: {
        slidesToShow: 5,
        slidesToScroll: 1
        }
      },
      {
        breakpoint: 790,
        settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        }
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
      ] 
    });


  $(".hp-num__section").waypoint(function() {

		$({
			blurRadius: 5
		}).animate({
			blurRadius: 0
		}, {
			duration: 1200,
			easing: 'swing',
			step: function() {
				$(".hp-num__number").css({
					"-webkit-filter": "blur(" + this.blurRadius + "px)",
					"filter": "blur(" + this.blurRadius + "px)"
				});
			}
		});
		var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(',');
		$(".hp-num__number").each(function() {
			var tcount = $(this).data("count");
			$(this).animateNumber({
					number: tcount,
					easing: 'easeInQuad',
					"font-size": "90px",
					numberStep: comma_separator_number_step
				},
				1200);
		});
		this.destroy();

	}, {
		offset: '60%'
	});

})

